import type { MetaData } from '../components/shared/types';
import { read } from '../utils/request';

export default async function ruleFetcher<
  Rule,
  Response extends {
    data: {
      rules: Array<Rule>;
      meta: MetaData;
    };
  }
>(path: string, callback: any) {
  let nextPage: number | null | undefined = null;
  do {
    const response: Response = await read(generate(path, nextPage));
    nextPage = response.data.meta.pagination.next_page;
    callback(response, !nextPage);
  } while (nextPage);
}

function generate(path: string, next: number | null | undefined) {
  if (next) {
    path += `?page=${next}`;
  }

  return path;
}
